import { SseEvent, SseEventName } from '@api/models';

/**
 * Eventos del canal de una división de cuenta pública (anfitrión y participantes). Un nombre que no esté en
 * el contrato no compila.
 */
export const COLLABORATIVE_SSE_EVENTS = [
  'participant-joined',
  'participant-submitted',
  'division-finalized',
] as const satisfies readonly SseEventName[];

export type CollaborativeSseEventType = (typeof COLLABORATIVE_SSE_EVENTS)[number];
export type CollaborativeSseEvent = SseEvent<CollaborativeSseEventType>;
